import React, { useEffect, useRef, forwardRef } from 'react';
import {
  Editor
} from 'slate';

import { initializeResizability } from './utilities';

import './index.css';

function Resizable(props, resizableMainReference) {

  var editor = props.editor;
  var elementPath = props.elementPath;
  var style = props.style;

  var pathRefHolder = useRef(null);

  useEffect(function onLoad() {

    pathRefHolder.current = Editor.pathRef(editor, elementPath);

    var uninitializeResizability = initializeResizability(editor, resizableMainReference.current, pathRefHolder);

    return function uninitialize() {

      uninitializeResizability();

      if (pathRefHolder.current !== null) {
        pathRefHolder.current.unref();
        pathRefHolder.current = null;
      }

    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function renderHandles() {

    return <React.Fragment>
      <div className="resize-handle right-handle"></div>
      <div className="resize-handle bottom-handle"></div>
    </React.Fragment>;

  }

  function renderMain() {

    var mainAttributes = {
      className: 'editor-resizable-layer-main',
      ref: resizableMainReference,
      style: style,
      contentEditable: false
    };

    return <div {...mainAttributes}>
      {renderHandles()}
      {props.children}
    </div>;

  }

  return renderMain();

}

export default forwardRef(Resizable);
